/** 与 holoview-test 对齐，便于共用同一后端与本地会话 */
export const AUTH_TOKEN_KEY = 'hv_token'
export const AUTH_USER_KEY = 'hv_user'
export const AUTH_GUEST_TOKEN_KEY = 'hv_guest_token'
export const AUTH_GUEST_USER_KEY = 'hv_guest_user'
export const AUTH_GUEST_SOLUTION_ID_KEY = 'hv_guest_solution_id'
export const AUTH_SSO_TOKEN_KEY = 'hv_sso_token'
export const AUTH_SSO_REFRESH_TOKEN_KEY = 'hv_sso_refresh_token'
export const AUTH_SSO_TOKEN_TYPE_KEY = 'hv_sso_token_type'
export const AUTH_SSO_EXPIRES_IN_KEY = 'hv_sso_expires_in'
export const AUTH_AUTHENTICATOR_KEY = 'hv_auth_authenticator'
export const AUTH_TOKEN_UPDATED_EVENT = 'holoview:auth-token-updated'
export const AUTH_AUTHENTICATOR_HEADER = 'X-Authenticator'
